import { useContext, createContext, useEffect, useState } from "react";
import { regUses, useTbl } from "../../axios_with_token";


const inventoryContext = createContext();
export function useInventoryContext(){
    return useContext(inventoryContext);
}

export default function InventoryContextProvider({children}){
    const [ tblInventoryChkItems, setTblInventoryChkItems ] = useState({});
    const [ cacheTimeStamp, setCacheTimeStamp ] = useState({});
    const {regUse, isLoading} = regUses();
    const getTbl = async tblName=>{
        // cache and update
        // how to make sure remote is up to date (self chang, 3rd party change)
        // 1. period, async not necessay
        // 2. action driven, async

        // status and refresh
        // check status and make refresh accordingly
    }
    const regAction = _=>{};
    // 1. check remote timestamp and localtimestam
    // 2. if return needRenew, renew local cache, otherwise, return cached
    // 3. some no cache ( with params ones (page list)), always update 
    const {} = regUse(useTbl());
    // useEffect(_=>{

    // }, []);
    // regChkAction
    return <inventoryContext.Provider
        value={{
            getTbl,
            isLoading
        }}
    >
        {children}
    </inventoryContext.Provider>;
}